module.exports = __webpack_public_path__ + "static/img/top-left.c05fa0bc.png";